import { render, staticRenderFns } from "./KorrespondenzVorlageInhalt.vue?vue&type=template&id=31f5e4f1"
import script from "./KorrespondenzVorlageInhalt.vue?vue&type=script&lang=js"
export * from "./KorrespondenzVorlageInhalt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports